export const SalutationEnum = {
  lookupTypeId: 1,
};
